import React, { useEffect, useState } from "react";
import { useDrop } from "react-dnd";
import { useEditProjectMutation } from "../../features/projects/projectsApi";
import { ItemTypes } from "../../utils/ItemTypes";

function ProjectColumn({ stateId, projectStateChange, children }) {
    const [editProject, isSuccess] = useEditProjectMutation();
    const [projectId, setProjectID] = useState("");

    useEffect(() => {
        projectStateChange(projectId, stateId);
    }, [isSuccess]);

    const dropItem = (item) => {
        if (stateId !== item.stateId) {
            const id = item.project.id;
            setProjectID(id);
            const data = {
                ...item.project,
                stateId: stateId,
            };
            editProject({ id, data });
        }
    };

    const [{ isOver }, drop] = useDrop({
        accept: ItemTypes.TYPE,
        drop: dropItem,
        collect: (monitor) => ({
            isOver: monitor.isOver(),
        }),
    });

    return (
        <div
            ref={drop}
            style={{
                minHeight: "100vh",
                background: isOver === true ? "#a1ccd787" : "",
            }}
            className="flex flex-col pb-2 overflow-auto"
        >
            {children}
        </div>
    );
}

export default ProjectColumn;
